export const USER_IS_VISITOR = "USER_IS_VISITOR";
export const USER_IS_ARCHIVED_IN_SELECTED_AY =
  "USER_IS_ARCHIVED_IN_SELECTED_AY";
export const USER_EXISTS_IN_OTHER_AYS = "USER_EXISTS_IN_OTHER_AYS";
export const USER_EXISTS_IN_SELECTED_AY = "USER_EXISTS_IN_SELECTED_AY";
export const EMAIL_CHANGED = "EMAIL_CHANGED";
export const EMAIL_ALREADY_EXISTS = "EMAIL_ALREADY_EXISTS";
export const USER_NOT_PRESENT_IN_ANY_AY = "USER_NOT_PRESENT_IN_ANY_AY";
